import type { User } from "../types/User";
import { storageKey } from "./storage-keys";
import { storageService } from "./storage-service";

export const getStoredAuthenticatedUser = () => {
  return storageService.getItemAsObject<User>(storageKey.user);
};
